import cx from "classnames";
import React from "react";
import styles from "./TwoCol.scss";

export const ColWrap = ({ className, children, ...props }) => {
  return (
    <div className={cx(styles.ColWrap, className)} {...props}>
      {children}
    </div>
  );
};

export const MainCol = ({ className, ...props }) => <div className={cx(styles.MainCol, className)} {...props} />;

export const SecondaryCol = ({ className, ...props }) => (
  <div className={cx(styles.SecondaryCol, className)} {...props} />
);
